import { useState, useMemo } from 'react';
import { CalendarEvent } from '../types';

export const useCalendar = () => {
    const [currentDate, setCurrentDate] = useState(new Date());
    const [selectedDate, setSelectedDate] = useState<Date | null>(null);

    // Mock data - in real app fetch from API
    const events: CalendarEvent[] = useMemo(() => [
        {
            id: 1,
            title: 'Bài tập React - Assignment 1',
            date: '2024-01-15',
            time: '23:59',
            type: 'deadline',
            course: 'React & TypeScript'
        },
        {
            id: 2,
            title: 'Live Session: Python Flask',
            date: '2024-01-18',
            time: '19:00',
            type: 'class',
            course: 'Python & Flask'
        },
        {
            id: 3,
            title: 'Workshop: Database Design',
            date: '2024-01-20',
            time: '14:00',
            type: 'event'
        },
        {
            id: 4,
            title: 'Nộp đồ án cuối kỳ',
            date: '2024-02-10',
            time: '23:59',
            type: 'deadline',
            course: 'Capstone Project'
        }
    ], []);

    const getEventsForDate = (date: Date) => {
        const dateStr = date.toISOString().split('T')[0];
        return events.filter(event => event.date === dateStr);
    };

    const nextMonth = () => {
        setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1));
    };

    const prevMonth = () => {
        setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1));
    };

    const goToToday = () => {
        const today = new Date();
        setCurrentDate(today);
        setSelectedDate(today);
    }

    return {
        currentDate,
        selectedDate,
        setSelectedDate,
        events,
        getEventsForDate,
        nextMonth,
        prevMonth,
        goToToday
    };
};
